import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  PreloadAllModules,
  provideRouter,
  TitleStrategy,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';
import { provideBdDataStates } from '@delen/bd-data-states';
import { provideBdUtilities } from '@delen/bd-utilities';
import { provideConnectAnalytics } from '@delen/connect-analytics';
import {
  LANGUAGE_CONFIG,
  localeInit,
  LocalizationMissingTranslationHandler,
  Localizer,
  provideConnectLocalization,
  SHOW_MISSING_TRANSLATIONS,
} from '@delen/connect-core';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { AppComponent } from './app/app.component';
import appRoutes from './app/app.routes';
import { CONFIG } from './app/core/config/config.token';
import { interceptorFunctions } from './app/core/interceptors/interceptor-functions';
import { AppTitleStrategy } from './app/features/shared/title-strategy';
import { config } from './config/config';
import { Config } from './config/config.interface';
import './localization/localization';

localeInit();

if (isDevMode()) window.BD_CONFIG = config;

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (localizer: Localizer) => () => localizer.init(),
      deps: [Localizer],
      multi: true,
    },
    {
      provide: SHOW_MISSING_TRANSLATIONS,
      useFactory: (cfg: Config) => cfg.showMissingTranslations,
      deps: [CONFIG],
    },
    {
      provide: LANGUAGE_CONFIG,
      useFactory: () => [
        { language: 'en-GB', fullname: 'English' },
        { language: 'nl-NL', fullname: 'Nederlands' },
        { language: 'nl-BE', fullname: 'Nederlands' },
        { language: 'fr-BE', fullname: 'Français' },
      ],
    },

    { provide: TitleStrategy, useClass: AppTitleStrategy },

    // Angular providers
    provideHttpClient(withInterceptors(interceptorFunctions), withInterceptorsFromDi()),
    provideRouter(appRoutes, withComponentInputBinding(), withPreloading(PreloadAllModules)),

    // 👇 3rd Party Providers
    provideAngularSvgIcon(),

    // 👇 Connect Providers
    provideConnectAnalytics({
      instrumentationKey: window.BD_CONFIG.azureAppInsightsInstrumentationKey,
      appName: window.BD_CONFIG.appName,
      teamName: window.BD_CONFIG.teamName,
      version: window.BD_CONFIG.version,
      pageViewBlacklist: [],
    }),
    provideConnectLocalization(),

    // 👇 BD-Component Providers
    provideBdUtilities(),
    provideBdDataStates(),

    // Import packages/modules with global services here
    importProvidersFrom(
      TranslateModule.forRoot({
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: LocalizationMissingTranslationHandler,
        },
      }),
    ),
  ],
})
  // eslint-disable-next-line no-alert
  .catch((err) => alert(err));
